import "./Hero.css"

export function Hero() {
  return (
    <section className="hero">
      <div className="hero-box">
        <div className="hero-text">
          <h1>Sarid Rafael</h1>
          <p>Menos trabas. Más trabajo.</p>
        </div>

        <img src="/images/perfil.png" alt="perfil" className="hero-img" />
      </div>
    </section>
  );
}